// extracted by mini-css-extract-plugin
export var text = "_4h-0";